import React, { useEffect, useRef, useState } from 'react';

import { BaseImage } from '../BaseImage';
import { Container } from '../Container';
import { Divider } from '../Divider';
import { Handle } from '../Handle';
import { Labels } from '../Labels';
import { Overlay } from '../Overlay';
import { OverlayImage } from '../OverlayImage';
import { DIVIDER_WIDTH, SLIDER_STARTING_POSITION } from '../../constants';

export const Slider = () => {
    const baseImageEl = useRef<HTMLDivElement>(null);
    const dividerEl = useRef<HTMLDivElement>(null);

    const [sliderWidth, setSliderWidth] = useState(0);
    const [sliderLeft, setSliderLeft] = useState(0);
    const [isSliding, setIsSliding] = useState(false);
    // Value between 0 and 1
    const [sliderPosition, setSliderPosition] = useState(
        SLIDER_STARTING_POSITION
    );

    const updateImagePosition = () => {
        if (!baseImageEl.current) return;

        const { width, left } = baseImageEl.current.getBoundingClientRect();

        setSliderWidth(width);
        setSliderLeft(left);
    };

    useEffect(() => {
        updateImagePosition();

        window.addEventListener('resize', updateImagePosition);

        return () => {
            window.removeEventListener('resize', updateImagePosition);
        };
    }, [baseImageEl]);

    const handleMouseUp = () => {
        setIsSliding(false);

        window.removeEventListener('mouseup', handleMouseUp);
    };

    const handleMouseDown = () => {
        setIsSliding(true);

        window.addEventListener('mouseup', handleMouseUp);
    };

    const moveSlider = (eventPosition: number) => {
        if (!baseImageEl.current) return;

        const mouseOffsetLeft = eventPosition - sliderLeft;
        const dividerLeftPosition = mouseOffsetLeft - DIVIDER_WIDTH / 2;

        // Max boundaries for slider
        if (
            dividerLeftPosition <= 0 ||
            dividerLeftPosition >= sliderWidth - DIVIDER_WIDTH
        ) {
            return;
        }

        const sliderPosition = dividerLeftPosition / sliderWidth;

        setSliderPosition(sliderPosition);
    };

    const handleMouseMove = (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        if (!isSliding) return;

        moveSlider(e.pageX);
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        moveSlider(e.touches[0].pageX);
    };

    return (
        <Container onMouseMove={handleMouseMove} onTouchMove={handleTouchMove}>
            <Labels
                leftLabel={'Normaal zicht'}
                rightLabel={'Met gepolariseerde glazen'}
            />
            <BaseImage
                ref={baseImageEl}
                src={
                    'https://pblx.s3.amazonaws.com/pnl/assets-www/js/compare-tool/img/gepolariseerd.jpg'
                }
            />
            <Overlay clipRight={sliderPosition * sliderWidth}>
                <OverlayImage
                    src={
                        'https://pblx.s3.amazonaws.com/pnl/assets-www/js/compare-tool/img/gepolariseerd-normaal.jpg'
                    }
                />
            </Overlay>
            <Divider
                left={sliderPosition * 100}
                ref={dividerEl}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <Handle />
            </Divider>
        </Container>
    );
};
